<template>
    <console-content max-width="1560">
        <v-row class="mt-4 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg text-start">교환 관리</v-col>
            <v-spacer/>
            <v-col cols="auto">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-2 mx-1">
                <v-card-title class="tit tit--xs font-weight-bold">검색필터</v-card-title>
                <v-card-text class="pb-0">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-date-field v-model="filter.createdAt[0]" label="주문일자" persistent-placeholder hide-details />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-date-field v-model="filter.createdAt[1]" label="주문일자" persistent-placeholder hide-details />
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-4 px-1" align="end">
            <v-col cols="auto" class="tit tit--xs">검색수 : {{ summary.totalCount.format() }}</v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table v-model="selected" :items="purchases" item-key="_id" :headers="purchasesHeaders" show-select hide-default-footer disable-pagination disable-sort class="mt-2 mx-1 elevation-1">
            <span slot="item.quantity" slot-scope="{item}">{{ item.quantity.format() }}개</span>
            <v-layout slot="item.product" slot-scope="{item}" align-center>
                <v-img :src="item.product.thumb" max-width="96" max-height="96" contain/>
                <div class="pl-4">
                    <div><b>{{ item.product.name }}</b></div>
                    <div>{{ item.product.salePrice.format() }}원</div>
                </div>
            </v-layout>
            <template slot="item.option-addition" slot-scope="{item}">
                <div v-if="item.product.type == 'option'">[{{ item.product.optionalNames.toString() }}] : {{ item.product.optionalValues.toString() }}</div>
                <div v-if="item.product.type == 'addition'">[{{ item.product.additionalName.toString() }}] : {{ item.product.additionalValue.toString() }}</div>
            </template>
            <div slot="item.order.buyer" slot-scope="{item}">
                <div>{{ item.order.buyer.name }} ({{ item.order.buyer.username }})</div>
                <div>{{ item.order.buyer.phone }}</div>
                <div>{{ item.order.buyer.email }}</div>
            </div>
            <div slot="item.order.receiver" slot-scope="{item}">
                <div>{{ item.order.receiver.name }}</div>
                <div>{{ item.order.receiver.phone }}</div>
                <div>{{ item.order.receiver.email }}</div>
            </div>
            <div slot="item.order.shippingAddress" slot-scope="{item}">
                <div>[{{ item.order.shippingAddress.postcode }}]</div>
                <div>{{ item.order.shippingAddress.address1 }}</div>
                <div>{{ item.order.shippingAddress.address2 }}</div>
            </div>
            <div slot="item.shippingInfo" slot-scope="{item}">
                <div>{{ item.shippingInfo.method }}</div>
                <div>{{ item.shippingInfo.invoiceNumber }}</div>
                <div>{{ couriers.find(courier => courier.value == item.shippingInfo.courier)?.text }}</div>
            </div>
            <span slot="item.order.totalAmount" slot-scope="{item}">{{ item.order.totalAmount.format() }}원</span>
            <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>

        <v-card class="mt-4">
            <v-card-text class="py-0">
                <v-row align="center">
                    <v-col cols="auto">
                        <v-sheet width="100">수거정보</v-sheet>
                    </v-col>
                    <v-col>
                        <v-btn outlined color="primary" @click="collecting">교환수거 처리</v-btn>
                        <v-btn outlined color="primary" class="ml-2" @click="collected">수거 완료처리</v-btn>
                    </v-col>
                </v-row>
                <v-divider class="my-2"/>
                <v-row align="center">
                    <v-col cols="auto">
                        <v-sheet width="100">교환처리</v-sheet>
                    </v-col>
                    <v-col>
                        <v-btn outlined color="primary" @click="reshipping">교환 재배송처리</v-btn>
                        <v-btn outlined color="primary" class="ml-2" @click="complete">교환 완료처리</v-btn>
                        <v-btn outlined color="primary" class="ml-2" @click="reject">교환 교환거부처리</v-btn>
                        <v-btn outlined color="primary" class="ml-2" @click="takeBack">반품으로 변경</v-btn>
                    </v-col>
                </v-row>
                <v-divider class="my-2"/>
                <v-row align="center">
                    <v-col cols="auto">
                        <v-sheet width="100">교환보류</v-sheet>
                    </v-col>
                    <v-col>
                        <v-btn outlined color="primary" @click="delay">교환보류 설정</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <return-dialog ref="returnDialog" />

    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import ReturnDialog from "@/components/console/shop/purchase/return-dialog.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";
import couriers from "@/assets/data/couriers.json";

export default {
    components: {
        ConsoleContent,
        ReturnDialog,
        VDateField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                createdAt: [ this.$route.query.createdAt?.[0] || '', this.$route.query.createdAt?.[1] || '' ],
                status: this.$route.query.status ? [...this.$route.query.status.toString().split(",")] : ["교환요청", "교환반려", "교환수거중", "교환수거완료", "교환재배송중", "교환재배송완료", "교환완료", "교환보류"]
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            selected: [],
            summary: { totalCount: 0 },
            purchases: [],
            purchasesHeaders: [
                { text: "주문번호", value: "order.orderNo", align: "center", width: 100 },
                { text: "구매번호", value: "purchaseNo", align: "center", width: 100 },
                { text: "구매상품", value: "product", align: "center", width: 250 },
                { text: "구매옵션", value: "option-addition", align: "center", width: 200 },
                { text: "구매수량", value: "quantity", align: "center", width: 80 },
                { text: "결제금액", value: "order.totalAmount", align: "center", width: 100 },
                { text: "구매자", value: "order.buyer", align: "center", width: 100 },
                { text: "수취인", value: "order.receiver", align: "center", width: 100 },
                { text: "배송지", value: "order.shippingAddress", align: "center", width: 150 },
                { text: "송장정보", value: "shippingInfo", align: "center", width: 150 },
                { text: "주문상태", value: "status", align: "center", width: 120 },
                { text: "결제상태", value: "paymentStatus", align: "center", width: 90 },
                { text: "교환사유", value: "reason", align: "center", width: 200 },
                { text: "교환요청내용", value: "demand", align: "center", width: 200 },
                { text: "주문일자", value: "createdAt", align: "center", width: 120 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
            ],

            couriers
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, purchases } = await api.console.shop.purchases.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.purchases = purchases;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        // 수거처리
        async collecting(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("수거 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "교환수거중",
                        purchaseStatus: "구매확정보류",
                    });
                }
                alert("교환수거 처리되었습니다");
                this.search(false);
            }
        },

        // 수거완료처리
        async collected(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("수거완료 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "교환수거완료",
                        purchaseStatus: "구매확정보류",
                    });
                }
                alert("수거완료 처리되었습니다");
                this.search(false);
            }
        },

        // 교환재배송처리
        async reshipping(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("교환재배송 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "교환재배송중",
                        purchaseStatus: "구매확정보류",
                    });
                }
                alert("교환재배송 처리되었습니다");
                this.search(false);
            }
        },

        // 교환완료처리
        async complete(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("교환완료 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "교환완료",
                        purchaseStatus: "구매확정대상",
                    });
                }
                alert("교환완료 처리되었습니다");
                this.search(false);
            }
        },

        // 교환거보처리
        async reject(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("교환거부 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "교환반려",
                        purchaseStatus: "구매확정대상",
                    });
                }
                alert("교환거부 처리되었습니다");
                this.search(false);
            }
        },

        // 반품으로 변경
        takeBack(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }

            this.$refs.returnDialog.$off();
            this.$refs.returnDialog.$on("input", async ({ reason, demand }) => {
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "반품요청",
                        purchaseStatus: "구매확정보류",
                        reason,
                        demand
                    });
                }
                alert("반품요청 처리되었습니다");
                this.search(false);
            });
            this.$refs.returnDialog.open();
        },

        // 교환보류 설정
        async delay(){
            if(!this.selected.length){
                alert("구매내역을 선택해주세요");
                return;
            }
            if(confirm("교환보류 처리하시겠습니까?")){
                for(let purchase of this.selected){
                    await api.console.shop.purchases.put({
                        _id: purchase._id,
                        status: "교환보류",
                        purchaseStatus: "구매확정보류",
                    });
                }
                alert("교환보류 처리되었습니다");
                this.search(false);
            }
        },


        async excel(){
            let { purchases } = await api.console.shop.purchases.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            purchases.forEach(purchase => {
                rows.push({
                    "주문번호": purchase?.order?.orderNo,
                    "구매번호": purchase?.purchaseNo,
                    "구매상품": purchase?.product?.name,
                    "구매옵션": (purchase?.product?.type == "option" || purchase?.product?.type == "addition") ? `[${purchase.product.optionalNames?.toString?.() || purchase.product.additionalName }] : ${purchase.product.optionalValues?.toString?.() || purchase.product.additionalValue }` : "",
                    "구매수량": purchase?.quantity?.format?.(),
                    "결제금액": purchase?.order?.totalAmount?.format?.(),
                    "구매자 이름": purchase?.order?.buyer?.name,
                    "구매자 아이디": purchase?.order?.buyer?.username,
                    "구매자 연락처": purchase?.order?.buyer?.phone,
                    "구매자 이메일": purchase?.order?.buyer?.email,
                    "수취인 이름": purchase?.order?.receiver?.name,
                    "수취인 연락처": purchase?.order?.receiver?.phone,
                    "수취인 이메일": purchase?.order?.receiver?.email,
                    "배송지": purchase?.order?.receiver?.postcode ? `[${purchase?.order?.receiver?.postcode}] ${purchase?.order?.receiver?.address1} ${purchase?.order?.receiver?.address2}` : '-',
                    "배송방법": purchase?.shippingInfo?.method,
                    "운송장번호": purchase?.shippingInfo?.invoiceNumber,
                    "택배사": couriers.find(courier => courier.value == purchase?.shippingInfo?.courier)?.text,
                    "주문상태": purchase?.status,
                    "결제상태": purchase?.paymentStatus,
                    "주문일자": this.$dayjs(purchase?.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "교환내역");
            XLSX.writeFile(workbook, "교환내역.xlsx");
        }
    }
}
</script>